import ToggableRefinementList from "components/screener/refinements/ToggableRefinementList";
import orderBy from "lodash/fp/orderBy";
import { connectRefinementList } from "react-instantsearch-dom";

const ListingSegmentRefinementList = connectRefinementList(({ items, refine }) => {
  const listingSegments = orderBy(["count"], ["desc"], items);

  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Segmento de Listagem</h3>

      {listingSegments.length === 0 && (
        <p className="font-aeonik text-sm font-normal tracking-wide text-slate-500">Nenhum segmento encontrado :(</p>
      )}

      <ToggableRefinementList
        refine={refine}
        items={listingSegments.map((item) => {
          if (item.label === "Nível 1 de Governança Corporativa") {
            return {
              ...item,
              label: "Nível 1",
            };
          }

          if (item.label === "Nível 2 de Governança Corporativa") {
            return {
              ...item,
              label: "Nível 2",
            };
          }
          return item;
        })}
      />
    </div>
  );
});

export default function ListingSegment() {
  return <ListingSegmentRefinementList attribute="listingSegment" />;
}
